import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal';
import Button from '../Button/Button';
import styles from './ConfirmationDialog.module.css';

interface ConfirmationDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDestructive?: boolean;
  isLoading?: boolean;
}

export default function ConfirmationDialog({
  title,
  message,
  confirmLabel,
  onConfirm,
  onCancel,
  isDestructive = false,
  isLoading = false,
}: ConfirmationDialogProps) {
  const { t } = useTranslation('common');
  return (
    <Modal title={title} onClose={onCancel}>
      <p className={styles.message}>{message}</p>
      <div className={styles.actions}>
        <Button
          variant={isDestructive ? 'destructive' : 'primary'}
          size="md"
          className={styles.actionBtn}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading ? t('deleting') : confirmLabel}
        </Button>
        <Button variant="secondary" size="md" className={styles.actionBtn} onClick={onCancel} disabled={isLoading}>
          {t('cancel')}
        </Button>
      </div>
    </Modal>
  );
}
